<div mat-dialog-content autoFocus="false">
  <div class="wrapper">
    <!-- Email Preview Pane -->
    <div class="email-preview-pane">
      <!-- Preview Controls -->

      <div class="email-preview-controls">
        <div class="layouts">
          <div class="device-previews">
            <button (click)="changePreviewWidth('100%')" mat-button>
              <mat-icon>computer</mat-icon>
              Desktop
            </button>
            <button (click)="changePreviewWidth('600px')" mat-button>
              <mat-icon>tablet_mac</mat-icon>
              Tablet
            </button>
            <button (click)="changePreviewWidth('320px')" mat-button>
              <mat-icon>phone_iphone</mat-icon>
              Mobile
            </button>
          </div>
          <div class="code-previews">
            <button (click)="toggleSourceCode()" mat-button>
              <mat-icon>code</mat-icon>
              Html
            </button>
          </div>
        </div>

        <div class="share-button">
          <button mat-raised-button color="primary" [appCopyToClipboard]="shareableURL">
            <mat-icon>share</mat-icon>
            <span>Share</span>
          </button>
        </div>
      </div>

      <!-- Email Preview and Sourcecode -->
      <div class="email-preview">
        <iframe id="email-preview-iframe" sandbox [srcdoc]="htmlContent | iTrustThisHtml"></iframe>
        <div>
          <textarea id="source-code" readonly>{{ htmlContent }}</textarea>
        </div>
      </div>
    </div>
    <!-- Email Information Pane -->
    <div class="email-info-pane">
      <button mat-icon-button mat-dialog-close class="close-modal">
        <mat-icon aria-label="Close">close</mat-icon>
      </button>
      <div class="email-info-container email-info">
        <div class="subject">
          <span class="info-label">Subject</span>
          {{ email.subject }}
        </div>
        @for (to of email.to; track to) {
          <div class="email-to-from">
            <span class="info-label">To</span>
            <span class="email-name">
              {{ to.name }}
            </span>
            <span class="email-email">({{ to.emailAddress }})</span>
          </div>
        }
        <div class="email-info-data email-info-name">
          <span class="info-label">From</span>
          <span class="email-name">
            {{ email.from.name }}
          </span>
          <span class="email-email">({{ email.from.emailAddress }})</span>
        </div>
        @if (!!email.replyTo) {
          <div class="email-info-data email-info-name">
            <span class="info-label">Reply-To</span>
            <span class="email-name">
              {{ email.replyTo.name }}
            </span>
            <span class="email-email">({{ email.replyTo.emailAddress }})</span>
          </div>
        }
      </div>

      <div class="dev-buttons">
        @if (!!vStoreLocation) {
          <a [href]="vStoreLocation" target="_blank">
            <button mat-raised-button>vStore Message</button>
          </a>
        }
        @if (!!codeLocation) {
          <a [href]="codeLocation" target="_blank">
            <button mat-raised-button>GitHub Source</button>
          </a>
        }
      </div>

      <!-- Secondary Information Tabs -->
      <!-- the @.disabled stops the tab switching animation -->
      <mat-tab-group [@.disabled]="true" [selectedIndex]="selectedTab" (selectedTabChange)="activeTab($event)">
        <!-- Events Tab -->
        <mat-tab label="Events">
          @if (events$ | async; as events) {
            <ul class="event-list">
              @for (e of events; track e) {
                <li>
                  <div class="event-row">
                    @switch (eventTypeToString(e.eventType)) {
                      @case ('OPENED') {
                        <mat-icon>drafts</mat-icon>
                      }
                      @case ('DELIVERED') {
                        <mat-icon>mail</mat-icon>
                      }
                      @case ('PROCESSED') {
                        <mat-icon>send</mat-icon>
                      }
                      @case ('BOUNCED') {
                        <mat-icon>trending_down</mat-icon>
                      }
                      @case ('DEFERRED') {
                        <mat-icon>replay</mat-icon>
                      }
                      @case ('DROPPED') {
                        <mat-icon>remove_circle_outline</mat-icon>
                      }
                      @default {
                        <mat-icon>crop_square</mat-icon>
                      }
                    }
                    <div class="event-details">
                      <h4 class="key">
                        {{ eventTypeToString(e.eventType) | titlecase }}
                      </h4>
                      @if (!!e.urlClicked) {
                        <p class="line">
                          {{ e.urlClicked }}
                        </p>
                      }
                      <p class="line">{{ e.eventTime | date: 'medium' }}</p>
                      @if (!!e.reason) {
                        <h4 class="value">
                          {{ e.reason }}
                        </h4>
                      }
                    </div>
                  </div>
                </li>
              }
            </ul>
          } @else {
            <mat-list-item>No events found</mat-list-item>
          }
        </mat-tab>
        <!-- Attributes Tab -->
        <mat-tab label="{{ 'EMAIL_REVIEW.MORE_INFO' | translate }}">
          <ul class="info-list">
            @for (inf of info; track inf) {
              <li>
                <div class="key">{{ inf.key }}</div>
                <div class="info-value">
                  <div>{{ inf.value }}</div>
                  <mat-icon
                    matTooltip="{{ 'COPY_TO_CLIPBOARD.COPY' | translate }}"
                    [appCopyToClipboard]="inf.value"
                    class="copy-icon"
                  >
                    file_copy
                  </mat-icon>
                </div>
              </li>
            }
          </ul>
        </mat-tab>
        @if (showSpamScore) {
          <mat-tab>
            <ng-template mat-tab-label>
              <div class="spam-tab">
                <div class="spam-text">{{ 'EMAIL_REVIEW.SPAM.SPAM' | translate }}</div>
                @if ((this.is_loading$ | async) === false) {
                  @if (!spamScore.isSpam) {
                    <div class="spam-passed">
                      <mat-icon class="spam-score-approved">check_circle_outline</mat-icon>
                    </div>
                  } @else {
                    <ng-container [ngTemplateOutlet]="spamFailed"></ng-container>
                  }
                } @else {
                  <ng-container [ngTemplateOutlet]="loading"></ng-container>
                }
              </div>
            </ng-template>
            <ul class="info-list">
              <div>
                <div class="key">{{ 'EMAIL_REVIEW.SPAM.SCORE' | translate }}</div>
                <div class="info-value">
                  @if ((this.is_loading$ | async) === false) {
                    <div>{{ spamScore?.score }}</div>
                  } @else {
                    <ng-container [ngTemplateOutlet]="loading"></ng-container>
                  }
                  <mat-icon
                    matTooltip="{{ 'COPY_TO_CLIPBOARD.COPY' | translate }}"
                    [appCopyToClipboard]="spamScore.score.toString()"
                    class="copy-icon"
                  >
                    file_copy
                  </mat-icon>
                </div>
              </div>
              <div>
                <div class="key">{{ 'EMAIL_REVIEW.SPAM.IS_SPAM' | translate }}</div>
                <div class="info-value">
                  @if ((this.is_loading$ | async) === false) {
                    <div>{{ spamScore?.isSpam }}</div>
                  } @else {
                    <ng-container [ngTemplateOutlet]="loading"></ng-container>
                  }
                </div>
              </div>
            </ul>
          </mat-tab>
        }
      </mat-tab-group>
    </div>
  </div>
</div>

<ng-template #loading>
  <div class="loading">
    <mat-spinner diameter="25" />
  </div>
</ng-template>

<ng-template #spamFailed>
  <div class="spam-failed">
    <mat-icon class="spam-score-approved">cancel</mat-icon>
  </div>
</ng-template>
